export default function getStatValue(stat) {
    let value = 0;
    if(stat.valueType === 'number') value = stat.number;
    else if(stat.valueType === 'dieSize') value = stat.dieSize;
    else if(stat.valueType === 'dicePool') value = stat.dicePool;
    else if(stat.valueType === 'formula') value = stat.calculated;
    if (!value) value = 0;
    return value;
}